exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clock[data-v-aba95ca0]{text-align:center;margin-top:20px}.time[data-v-aba95ca0]{font-size:1.5em;font-weight:700}", ""]);

// exports
